import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':toolId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:toolId`;

export const URL = (toolId: number): RouteDefinition => `${baseRoute}/${toolId}`;
